import { createInjectionKey } from "../../_utils/index.mjs";
export const formInjectionKey = createInjectionKey('n-form');
export const formItemInstsInjectionKey = createInjectionKey('n-form-item-insts');